import { ConnectionState } from '../api/ws_client';

export class TelemetryMonitor {
  private lastTickTimestamp: number = Date.now();
  private tickToRenderLatencies: number[] = [];
  private fps: number = 60;
  private frameCount: number = 0;
  private lastFpsCheck: number = performance.now();
  private sequenceGaps: number = 0;
  private connectionState: ConnectionState = 'OFFLINE';
  private listeners = new Set<() => void>();

  constructor() {
    this.startFPSLoop();
  }

  public subscribe(listener: () => void): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify() {
    this.listeners.forEach(fn => fn());
  }

  public recordTick(serverTimestampIso: string) {
    const serverTime = new Date(serverTimestampIso).getTime();
    const renderTime = Date.now();
    const latency = Math.max(0, renderTime - serverTime);

    this.lastTickTimestamp = renderTime;
    this.tickToRenderLatencies.push(latency);
    if (this.tickToRenderLatencies.length > 200) {
      this.tickToRenderLatencies.shift();
    }
    this.notify();
  }

  public recordGap() {
    this.sequenceGaps++;
    this.notify();
  }

  public setConnectionState(state: ConnectionState) {
    this.connectionState = state;
    this.notify();
  }

  public getP95TickToRenderLatency(): number {
    if (this.tickToRenderLatencies.length === 0) return 0;
    const sorted = [...this.tickToRenderLatencies].sort((a, b) => a - b);
    const idx = Math.floor(sorted.length * 0.95);
    return sorted[Math.min(idx, sorted.length - 1)];
  }

  public getFeedFreshnessMs(): number {
    return Math.max(0, Date.now() - this.lastTickTimestamp);
  }

  public getFPS(): number {
    return this.fps;
  }

  public getSequenceGaps(): number {
    return this.sequenceGaps;
  }

  public getConnectionState(): ConnectionState {
    return this.connectionState;
  }

  private startFPSLoop() {
    const countFrame = () => {
      this.frameCount++;
      const now = performance.now();
      if (now - this.lastFpsCheck >= 1000) {
        this.fps = Math.round((this.frameCount * 1000) / (now - this.lastFpsCheck));
        this.frameCount = 0;
        this.lastFpsCheck = now;
        this.notify();
      }
      requestAnimationFrame(countFrame);
    };
    requestAnimationFrame(countFrame);
  }
}
